const Token = "Mc-Token"; //Mc-Token
const Info = "Mc-Info";
export default {
	getToken:() => {
		// return sessionStorage.getItem(Token);
		return localStorage.getItem(Token);
	},
	setToken:(data) => {
		// return sessionStorage.setItem(Token,data);
		return localStorage.setItem(Token,data);
	},
	removeToken:() => {
		// return sessionStorage.clear();
		return localStorage.removeItem(Token);
	},
	getInfo:() => {
		// return sessionStorage.getItem(Info);
		return localStorage.getItem(Info);
	},
	setInfo:(data) => {
		// return sessionStorage.setItem(Info,data);
		return localStorage.setItem(Info,data);
	},
	removeInfo:() => {
		// return sessionStorage.clear();
		return localStorage.removeItem(Info);
	}
}


